const newsData = [
    {
        id:"1",
        image:require("../../assets/image/news.png"),
        title:"test new",
        description:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        data:"17/5/2025"
    },
    {
        id:"2",
        image:require("../../assets/image/news.png"),
        title:"test new",
        description:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        data:"17/5/2025"
    },
    {
        id:"3",
        image:require("../../assets/image/news.png"),
        title:"test new",
        description:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        data:"17/5/2025"
    },
]

export default newsData;